import { useState } from 'react';

interface Category {
  name: string;
  href: string;
}

const categories: Category[] = [
  { name: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', href: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', href: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', href: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const categoryIcons: Record<string, string> = {
  'Shoes': 'ri-footprint-line',
  'Hoodies / Sweaters': 'ri-t-shirt-line',
  'T-Shirts': 'ri-shirt-line',
  'Jackets': 'ri-honour-line',
  'Pants / Shorts': 'ri-tools-line',
  'Headwear': 'ri-user-smile-line',
  'Sets': 'ri-stack-line',
  'Underwear / Underpants': 'ri-checkbox-blank-circle-line',
  'Jersey': 'ri-football-line',
  'Accessories': 'ri-star-line',
  'Bags': 'ri-shopping-bag-3-line',
  'Belts': 'ri-link',
  'Perfumes': 'ri-drop-line',
  'Other Stuff': 'ri-more-line',
};

export default function CategoriesSection() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);

  const handleSelect = (cat: Category) => {
    setSelectedCategory(cat);
    setIsOpen(false);
    window.open(cat.href, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">

        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Select a category below to explore thousands of curated products on our main website. Every category is regularly updated with fresh finds.
          </p>
        </div>

        <div className="relative max-w-md mx-auto mb-12">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 rounded-lg bg-background-100 border border-background-200/70 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-grid-line text-primary-500"></i>
              {selectedCategory ? selectedCategory.name : 'Choose a category...'}
            </span>
            <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)}></div>
              <div className="absolute top-full left-0 right-0 mt-1 z-20 bg-background-50 rounded-lg border border-background-200/70 shadow-lg max-h-72 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat)}
                    className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 cursor-pointer text-left"
                  >
                    <i className={`${categoryIcons[cat.name] || 'ri-folder-line'} text-primary-500 w-5 h-5 flex items-center justify-center`}></i>
                    {cat.name}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.href}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${categoryIcons[cat.name] || 'ri-folder-line'} text-primary-600 text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap transition-colors duration-200">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}